<template>
    <form v-if="employee_extended && hasAccess" class="pt-4">
        <top-nav-bar goto="/?page=profile"></top-nav-bar>

        <div class="pb-8 clearfix">
            <div class="flex flex-col sm:flex-row">
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="pension_scheme" :label="trans('crewman::pension.state.pension_scheme')">
                        <input disabled type="text" class="input" :value="employee_extended.pension.pension_scheme">
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="retirement_age" :label="trans('crewman::pension.state.retirement_age')">
                        <input disabled type="text" class="input" :value="employee_extended.pension.retirement_age">
                    </form-group>
                </div>
            </div>

            <div class="flex flex-col sm:flex-row">
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="employers_contribution"
                                :label="trans('crewman::pension.state.employers_contribution')">
                        <input disabled type="text" class="input"
                               :value="employee_extended.pension.employers_contribution">
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="employees_contribution"
                                :label="trans('crewman::pension.state.employees_contribution')">
                        <input disabled type="text" class="input"
                               :value="employee_extended.pension.employees_contribution">
                    </form-group>
                </div>
            </div>

            <div class="flex flex-col sm:flex-row">
                <div class="sm:w-1/2 px-4 pb-0 sm:pb-4">
                    <form-group name="additional_contribution"
                                :label="trans('crewman::pension.state.additional_contribution')">
                        <input disabled type="text" class="input"
                               :value="employee_extended.pension.additional_contribution">
                    </form-group>
                </div>
            </div>

            <div class="block md:inline-flex md:float-right px-4">
                <button class="btn btn--colored__green w-full disabled" disabled="disabled" type="submit">
                    <i class="fal fa-check"></i>
                    {{ trans('crewman::common.button.save') }}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {mapState} from 'vuex';
    import CanAccessView from "../mixins/CanAccessView";

    export default {
        mixins: [CanAccessView],
        computed: {
            ...mapState(['employee_extended']),
        },
    }
</script>
